// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"e_i4","popupBlock":"e_j4"};